export const getSafeName = (pkgName) => {
    if (!pkgName) {
        return pkgName;
    }
    return pkgName
        .replace(/(-)([a-z])/g, function (_, __, x) {
        return x.toUpperCase();
    })
        .replace(/\//, '__')
        .replace(/[^a-zA-Z\_]/g, '');
};
//# sourceMappingURL=get-safe-name.js.map